import { createFileRoute } from '@tanstack/react-router';
import { ImportPage } from '@/features/inventory/pages/import-page';

export const Route = createFileRoute('/_app/inventory/import')({ component: ImportPage });
